import {
  type RowWithReports,
  isTableCellValueWithReport,
} from '@ipfabric/utils';
import type { TableRowMeta } from 'components/Table/model/TableRowMeta';

export const extractRowMetaInfo = <TRow,>(
  row: RowWithReports<TRow>,
): TRow & TableRowMeta =>
  Object.entries(row).reduce<TRow & TableRowMeta>(
    (acc, [key, value]) => {
      if (isTableCellValueWithReport(value)) {
        // would be inefficiently tricky to type
        (acc as any)[key] = value.data;
        acc.$severity = acc.$severity ?? {};
        acc.$severity[key] = value.severity;
      } else {
        (acc as any)[key] = value;
      }
      return acc;
    },
    {} as TRow & TableRowMeta,
  );
